import hiddenList from "@scripts/modules/hidden-list";

hiddenList(".areas", UI_LOCALIZATION.btnShowAllAreas, UI_LOCALIZATION.btnHideList);
